/**
 * @generated SignedSource<<ad013d8d4a5464d7fd874dec98d202a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteContactInput = {
  id: string;
};
export type DeleteContactDialogMutation$variables = {
  input: DeleteContactInput;
};
export type DeleteContactDialogMutation$data = {
  readonly deleteContact: {
    readonly id: string;
  };
};
export type DeleteContactDialogMutation = {
  response: DeleteContactDialogMutation$data;
  variables: DeleteContactDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteContactDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteContact",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteContactDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteContact",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ddc923409b602653d1f221ebda6d1901",
    "id": null,
    "metadata": {},
    "name": "DeleteContactDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteContactDialogMutation(\n  $input: DeleteContactInput!\n) {\n  deleteContact(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c973f3f9113fb2a008d6f9ec919d9b4";

export default node;
